import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data.user);
        // strip hash
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error("Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center text-muted-foreground" data-testid="auth-callback-loading">
      Finishing sign-in…
    </div>
  );
}
